import React from "react"

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="25"
    viewBox="0 0 20 25">
    <g fill="#FFFFFF">
      <path d="M17,0 L3,0 C1.3,0 0,1.3 0,3 L0,19 C0,20.7 1.3,22 3,22 L1.4,23.2 C1,23.5 0.9,24.2 1.2,24.6 C1.4,24.9 1.7,25 2,25 C2.2,25 2.4,24.9 2.6,24.8 L6.3,22 L13.6,22 L17.3,24.8 C17.5,24.9 17.7,25 17.9,25 C18.2,25 18.5,24.9 18.7,24.6 C19,24.2 18.9,23.5 18.5,23.2 L17,22 C18.7,22 20,20.7 20,19 L20,3 C20,1.3 18.7,0 17,0 Z M3,2 L17,2 C17.6,2 18,2.4 18,3 L18,12 L2,12 L2,3 C2,2.4 2.4,2 3,2 Z M17,20 L3,20 C2.4,20 2,19.6 2,19 L2,14 L18,14 L18,19 C18,19.6 17.6,20 17,20 Z" />
      <path d="M13,16 L7,16 C6.4,16 6,16.4 6,17 C6,17.6 6.4,18 7,18 L13,18 C13.6,18 14,17.6 14,17 C14,16.4 13.6,16 13,16 Z" />
      <circle cx="16" cy="17" r="1" />
      <circle cx="4" cy="17" r="1" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/icons/SmallTrain.js